import type { Board } from "../board";
import { Direction } from "../direction";
import { BallisticMovementEffect } from "../effects/ballisticMovementEffect";
import { Explosion } from "../effects/explosion";
import { STANDARD_MOVEMENT_TIME } from "../effects/movementEffect";
import { Shrapnel } from "../projectiles/shrapnel";
import { randomElement, randomInt } from "../random";
import type { XY } from "../xy";
import { Sound } from "./sounds/sound";
import { SoundId } from "./sounds/soundId";
import type { MultiTileThingCore } from "./multitile/multiTileThingCore";
import { ScrapMetal } from "./scrapMetal";

export function addDestroyEffectToBoard(board: Board, core: MultiTileThingCore): void {
	if (!core.controller) return;
	const xy = core.controller.getBottomLeftXY();
	board.addNonPhysicalThing(new Sound(SoundId.ROBOT_DIE, xy));
	board.addNonPhysicalThing(new Sound(SoundId.EXPLOSION, xy));
	for (const part of core.controller.getParts()) {
		board.addEffect(new Explosion(part.xy));
		board.addThing(new ScrapMetal(part.xy));
	}
	const startingPoints = [...core.controller.getParts()].map((p) => p.xy);
	placeShrapnelEffect(board, startingPoints, xy, randomInt(10, 18), 5);
}

export function placeShrapnelEffectSingle(board: Board, xy: XY, numberOfShrapnel: number, radius: number): void {
	placeShrapnelEffect(board, [xy], xy, numberOfShrapnel, radius);
}

export function placeShrapnelEffect(
	board: Board,
	startingPoints: XY[],
	center: XY,
	numberOfShrapnel: number,
	radius: number,
): void {
	const area = center.getAreaInSquareRadius(radius).filter((p) => p.isInside(board));
	// Shuffle
	for (let i = area.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[area[i], area[j]] = [area[j], area[i]];
	}
	const count = Math.min(numberOfShrapnel, area.length);
	for (let i = 0; i < count; i++) {
		const target = area[i];
		const origin = randomElement(startingPoints) ?? center;
		if (origin.equals(target)) continue;
		const shrapnel = new Shrapnel(origin, Direction.W);
		const time = STANDARD_MOVEMENT_TIME * (1.7 + Math.random() * 3);
		const effect = new BallisticMovementEffect(shrapnel, origin, target, time);
		effect.height = 2;
		board.addEffect(effect);
	}
}
